import styled from '@emotion/styled';

export const BlockingBackground = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: var(--surface-main-modal-backdrop);
  top: 0;
  left: 0;
  z-index: 999;
`;
